import axios from "axios";

export const api = axios.create({
  //baseURL: process.env.REACT_APP_API_BASE + "/api" || "http://192.168.0.9:5000/api",
  baseURL: '/api',
  withCredentials: true, // viktiga cookies (session)
});